import React from 'react';
import './FeaturedBlog.css';
import { Link } from 'react-router-dom';
import arrowFeatureBlog from '../../../assets/Blog/Arrowblog.svg'
const FeaturedBlog = ({ id, imageSrc, category, title, date }) => {
  return (
    <div>
      <h2 className="featured-heading">FEATURED</h2>
      <div className="featured-blog">
        <div className="featured-content">
          <div className='featured-category'>
            <span className="featured-category-label">{category}</span>
          </div>
          <h2>{title}</h2>
          <p>{date}</p>
          <Link to={`/blog/${id}`} className="read-more-button">
            Read More
            <span className="svg-wrapper">
              <img src={arrowFeatureBlog} alt="arrow" className="arrow-svg" />
            </span>
          </Link>
        </div>
        <div className="featured-image-wrapper">
          <img src={imageSrc} alt={title} className="featured-image" />
        </div>
      </div>
    </div>
  );
};

export default FeaturedBlog;
